import { defineStore } from 'pinia';

export const useGeolocationStore = defineStore('geolocationStore', {
    state: () => ({
        isAllowed: false
    })
});
